module.exports = __webpack_public_path__ + "img/wf2.88273bf2.png";